import { RestUrl } from "../common/cyan.types";

export class S3Url {
  public static createDocumentSignerPresignedUrlForUpload: RestUrl = ["POST", "/s3/document-signers/presigned-url"];
  public static validateDocumentSignerStampImage: RestUrl = ["POST", "/s3/document-signers/validate-stamp"];
  public static createPresignedUrlForUpload: RestUrl = ["POST", "/s3/presigned-url"];
  public static createPresignedUrlForBulkUpload: RestUrl = ["POST", "/s3/presigned-url/bulk"];
  public static createPresignedUrlForRead: RestUrl = ["GET", "/s3/presigned-url"];
  public static copyTempToLiveBucket: RestUrl = ["POST", "/s3/files/promote"];
}
